module.exports = __webpack_public_path__ + "img/20.1bb45006.png";